import { ModelStatus as ModelStatusEnum } from 'dashboard409a/pages/Workboard/common/types';

// Map between ModelStatusEnum (UI) and Fulfillment.model_status (API) values
const modelStatusMap = ({
  [ModelStatusEnum.DRAFT]: 0,
  [ModelStatusEnum.REVIEW]: 1,
  [ModelStatusEnum.IN_PROCESS_SCALAR_USA]: 2,
  [ModelStatusEnum.FINAL]: 3,
  [ModelStatusEnum.COMPLETE]: 4,
  [ModelStatusEnum.WAITING]: 5,
});

// Reverse map for converting API values back to UI values
const reverseModelStatusMap = ({
  0: ModelStatusEnum.DRAFT,
  1: ModelStatusEnum.REVIEW,
  2: ModelStatusEnum.IN_PROCESS_SCALAR_USA,
  3: ModelStatusEnum.FINAL,
  4: ModelStatusEnum.COMPLETE,
  5: ModelStatusEnum.WAITING,
});

const userSearchStaleTime = 5 * 60 * 1000;
const userSearchQueryKey = 'staff-users-search';


export { modelStatusMap, reverseModelStatusMap, userSearchStaleTime, userSearchQueryKey };